import axios from "axios";

let axiosInstance = axios.create({
  baseURL: window?.location?.origin,
  // baseURL: "http://localhost:8080",
  timeout: 40000,
});

function configAxios() {
  axiosInstance = axios.create({
    // baseURL: "https://portal.rapidresourcingltd.co.uk",
    // baseURL: "http://localhost:8080",
    baseURL: window?.location?.origin,
    timeout: 40000,
  });
}

// axiosInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     console.log("error", error);
//     if (error.response.status === 401 || error.response.status === 403 || error.response == "Unauthorized") {
//         localStorage.clear();
//         window.location.href = '/login';
//     }
//   }
// );



// Function to handle errors globally
function handleError(error) {
  console.error("API Error:", error);

  if (error.response) {
    const { status } = error.response;
    
    // Handle JWT expiration
    if (status === 401 || status === 403) {
      console.warn("Session expired. Redirecting to login...");
      localStorage.clear();
      window.location.href = "/login";
    }
  }

  return Promise.reject(error); // Ensure the calling function can still handle errors
}

function getHeaders(token) {
  return {
    Authorization: token && `Bearer ${token}`,
    "Access-Control-Allow-Origin": "*",
    // 'subscription-key': getSubscriptionKey(),
    // 'x-correlation-id': getLocalStorage(CORRELATION_ID)
  };
}

export async function post(url, userData, token) {
  try {
    configAxios();
    return axiosInstance({
      method: "POST",
      url,
      data: userData,
      headers: getHeaders(token),
    });
  } catch (error) {
    return handleError(error);
  }
}

export async function uploadFile(file, token, candidateId = null) {
  try {
    const formData = new FormData();
    formData.append("file", file);
    if (candidateId) {
      formData.append("candidateId", candidateId);
    }
    configAxios();
    const { data } = await axiosInstance({
      method: "POST",
      url: "/api/document/upload",
      data: formData,
      headers: { ...getHeaders(token), "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function uploadTemplate(file, token) {
  try {
    const formData = new FormData();
    formData.append("file", file);
    configAxios();
    const { data } = await axiosInstance({
      method: "POST",
      url: "/api/template/upload",
      data: formData,
      headers: { ...getHeaders(token), "Content-Type": "multipart/form-data" },
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function postMultiPartFormData(url, userData, token) {
  try {
    configAxios();
    return axiosInstance({
      method: "POST",
      url,
      data: userData,
      headers: { ...getHeaders(token), "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    return handleError(error);
  }
}

export async function putMultiPartFormData(url, userData) {
  try {
    configAxios();
    return axiosInstance({
      method: "PUT",
      url,
      data: userData,
      headers: { ...getHeaders(), "Content-Type": "multipart/form-data" },
    });
  } catch (error) {
    return handleError(error);
  }
}

export async function del(url, token, userData) {
  try {
    configAxios();
   return axiosInstance({
      method: "DELETE",
      url,
      data: userData,
      headers: getHeaders(token),
    });
  } catch (error) {
    return handleError(error);
  }
}

export async function get(url, token) {
  try {
    configAxios();
    const { data } = await axiosInstance({
      method: "GET",
      url,
      headers: getHeaders(token),
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}

export async function put(url, data, token) {
  try {
    configAxios();
    return axiosInstance({
      method: "PUT",
      url,
      data,
      headers: getHeaders(token),
    });
  } catch (error) {
    return handleError(error);
  }
}

export async function getDropDownvalues(lovType, token) {
  try {
    configAxios();
    const url = `/api/lov/${lovType}`;
    const { data } = await axiosInstance({
      method: "GET",
      url,
      headers: getHeaders(token),
    });
    return data;
  } catch (error) {
    return handleError(error);
  }
}
